import { render, staticRenderFns } from "./ListDialog.vue?vue&type=template&id=033273f4&scoped=true"
import script from "./ListDialog.vue?vue&type=script&lang=js"
export * from "./ListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033273f4",
  null
  
)

export default component.exports